import {Action, State} from '../../types/calendarState.types';
import {CALENDAR_VIEW} from '../constants';
import {calendarStartingDate} from '../Module/General';

export const initialState = {
    index: CALENDAR_VIEW,
    selectedData: [],
    selectedEvent: {},
    dates: [],
    ...calendarStartingDate
};

export const calendarReducer = (state: State, payload: Action): State => {
    switch (payload.type) {
        case 'UPDATE_CALENDAR_VIEW':
            return {...state, index: payload.data as number};
        case 'SHOW_EVENTS_FOR_SELECTED_DATE':
            return {...state, selectedData: payload.data as any[]};
        case 'UPDATE_DATES':
            return {...state, dates: payload.data as any[]};
        case 'MONTH_FORWARD': {
            if (state.month === 12) return {...state, month: 1, year: state.year + 1};
            return {...state, month: state.month + 1};
        }

        case 'MONTH_BACKWARD': {
            if (state.month === 1) return {...state, month: 12, year: state.year - 1};
            return {...state, month: state.month - 1};
        }
        default:
            return state;
    }
};
